import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Catches auth-related query params (code, token_hash, type, error) that land on
 * a route other than /auth/callback and redirects them there.
 *
 * This handles the case where Supabase falls back to the Site URL (root) instead
 * of the configured redirectTo URL — e.g. when the redirect URL isn't in the
 * Dashboard allow-list or the email template uses {{ .SiteURL }}.
 */
const AuthParamsRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/auth/callback') return;

    const params = new URLSearchParams(location.search);
    const hasAuthParams =
      params.has('code') ||
      params.has('token_hash') ||
      (params.has('type') && ['recovery', 'signup', 'email_change', 'magiclink'].includes(params.get('type') || ''));

    if (hasAuthParams) {
      navigate(`/auth/callback${location.search}${location.hash}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default AuthParamsRedirect;
